// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---src-pages-families-index-tsx": () => import("./../../../src/pages/families/index.tsx" /* webpackChunkName: "component---src-pages-families-index-tsx" */),
  "component---src-pages-index-tsx": () => import("./../../../src/pages/index.tsx" /* webpackChunkName: "component---src-pages-index-tsx" */),
  "component---src-pages-plans-index-tsx": () => import("./../../../src/pages/plans/index.tsx" /* webpackChunkName: "component---src-pages-plans-index-tsx" */),
  "component---src-pages-products-index-tsx": () => import("./../../../src/pages/products/index.tsx" /* webpackChunkName: "component---src-pages-products-index-tsx" */),
  "component---src-pages-species-index-tsx": () => import("./../../../src/pages/species/index.tsx" /* webpackChunkName: "component---src-pages-species-index-tsx" */),
  "component---src-pages-users-index-tsx": () => import("./../../../src/pages/users/index.tsx" /* webpackChunkName: "component---src-pages-users-index-tsx" */)
}

